import React from 'react';
import './ReceiptProduct.css'
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';

function ReceiptProduct({id, title, price, img, qnt}) {
    const [{ basket }, dispatch] = useStateValue();
    
    return (
        <div className='receiptProduct'>
            <div className="receiptProduct__left"><img className="receiptProduct__img" src={img} alt="cart"/></div>
            <div className="receiptProduct__right">
                <div className="receiptProduct__up">
                    <h4>{title}</h4>
                    <div className="receiptProduct__btn">
                    </div>
                </div>
                <div className="receiptProduct__down">
                    <div className='receiptProduct__price'>
                        <strong>Price</strong>
                        <CurrencyFormat
                            renderText={(value) => (
                                <>
                                    <small>{value}</small>
                                </>
                            )}
                            decimalScale={2}
                            value={price}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                        />
                    </div>
                    <div className='receiptProduct__qnt'>
                        <strong>Quantity</strong>
                        <div>
                            <label>{qnt}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReceiptProduct